import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { FlatList } from 'react-native';

import { LoadingTable } from '../LoadingTable';

import { tableHead } from './constants';

import { CustomerTiesContainerDataProps } from '.';

interface ProductItemProps {
  item: CustomerTiesContainerDataProps['data'][0];
}

export const ProductItemValueTablet: React.FC<{ value: string; label: string }> = ({
  value,
  label,
}) => {
  return (
    <VStack space={Spacing['stack.nano']} px={Spacing['inline.xxxs']}>
      <UI.Text variant="semibold">{label}</UI.Text>
      <UI.Text>{value}</UI.Text>
    </VStack>
  );
};

export const ProductItemTablet: React.FC<ProductItemProps> = ({ item }) => {
  return (
    <UI.Shadow
      level={1}
      p={Spacing['inset.xs']}
      my={Spacing['stack.nano']}
      borderRadius={BoxBorder.heavy}>
      <HStack alignItems="center" justifyContent="space-between">
        <ProductItemValueTablet label={tableHead.product} value={item.nomeProduto} />
        <HStack>
          <ProductItemValueTablet
            label={tableHead.date}
            value={Utils.Mask.DateFormat(item.dataAdesao, 'dd/MM/yyyy - HH:mm:ss')}
          />
          <ProductItemValueTablet label={tableHead.status} value={item.status} />
        </HStack>
      </HStack>
    </UI.Shadow>
  );
};

export const ContentTablet: React.FC<CustomerTiesContainerDataProps> = ({ isLoading, data }) => {
  return (
    <VStack my={Spacing['inset.sm']} paddingY={Spacing['inline.xxs']}>
      {isLoading ? (
        <LoadingTable columns={3} />
      ) : (
        <FlatList
          windowSize={20}
          maxToRenderPerBatch={20}
          updateCellsBatchingPeriod={5}
          data={data}
          // ListEmptyComponent={<LoadingTable columns={columns} />}
          showsVerticalScrollIndicator={false}
          // onEndReached={handleEndReached}
          onEndReachedThreshold={1.5}
          // ListFooterComponent={loadingFooter}
          renderItem={({ item }) => <ProductItemTablet item={item} />}
        />
      )}
    </VStack>
  );
};
